import { AnchorAsButton } from '@packages/ui/base/button/anchor_as_button';

export const NotFoundPage = () => {
  return (
    <div className="bg-primary-gradient text-primary-foreground flex h-screen flex-col items-center justify-center px-4">
      <div className="text-center">
        <h2 className="text-8xl font-bold">404</h2>
        <p className="mx-auto mt-4 mb-12 max-w-xs">
          Sorry, we can't seem to find what you are looking for.
        </p>
        <AnchorAsButton href="/">
          <span>Back to Homepage</span>
        </AnchorAsButton>
      </div>
    </div>
  );
};
